import React, { useState, useRef } from 'react';
import { Upload, X, ImageIcon } from 'lucide-react';
interface ImageUploadProps {
  value: string;
  onChange: (dataUrl: string) => void;
  label?: string;
  height?: string;
  accept?: string;
  maxSizeMB?: number;
  className?: string;
}
export function ImageUpload({
  value,
  onChange,
  label = 'Изображение',
  height = 'h-36',
  accept = 'image/png,image/jpeg,image/webp,image/gif',
  maxSizeMB = 5,
  className = ''
}: ImageUploadProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragOver, setDragOver] = useState(false);
  const [error, setError] = useState('');
  const handleFile = (file: File) => {
    setError('');
    if (!file.type.startsWith('image/')) {
      setError('Выберите изображение (PNG, JPG, WebP, GIF)');
      return;
    }
    if (file.size > maxSizeMB * 1024 * 1024) {
      setError(`Файл слишком большой (макс. ${maxSizeMB} МБ)`);
      return;
    }
    const reader = new FileReader();
    reader.onload = e => {
      const result = e.target?.result as string;
      if (result) onChange(result);
    };
    reader.readAsDataURL(file);
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) handleFile(file);
    if (inputRef.current) inputRef.current.value = '';
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files?.[0];
    if (file) handleFile(file);
  };
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setDragOver(true);
  };
  const handleDragLeave = () => setDragOver(false);
  const handleRemove = () => {
    onChange('');
    setError('');
  };
  return <div className={className} data-id="element-18839">
      {label && <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-18840">
          {label}
        </label>}

      <input ref={inputRef} type="file" accept={accept} onChange={handleInputChange} className="hidden" data-id="element-18841" />

      {value ? <div className={`relative ${height} rounded-xl overflow-hidden border border-slate-200 group`} data-id="element-18842">
          <img src={value} alt="Preview" className="w-full h-full object-cover" data-id="element-18843" />
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center gap-2 opacity-0 group-hover:opacity-100" data-id="element-18844">
            <button type="button" onClick={() => inputRef.current?.click()} className="px-3 py-1.5 bg-white rounded-lg text-xs font-medium text-slate-700 hover:bg-slate-50 transition-colors shadow-sm" data-id="element-18845">
              Заменить
            </button>
            <button type="button" onClick={handleRemove} className="w-8 h-8 bg-white rounded-lg flex items-center justify-center text-rose-500 hover:bg-rose-50 transition-colors shadow-sm" data-id="element-18846">
              <X className="w-4 h-4" data-id="element-18847" />
            </button>
          </div>
        </div> : <div onClick={() => inputRef.current?.click()} onDrop={handleDrop} onDragOver={handleDragOver} onDragLeave={handleDragLeave} className={`${height} rounded-xl border-2 border-dashed ${dragOver ? 'border-indigo-400 bg-indigo-50/50' : 'border-slate-200 hover:border-indigo-300 hover:bg-indigo-50/30'} flex flex-col items-center justify-center cursor-pointer transition-all`} data-id="element-18848">
          <div className={`w-10 h-10 rounded-lg ${dragOver ? 'bg-indigo-100' : 'bg-slate-100'} flex items-center justify-center mb-2 transition-colors`} data-id="element-18849">
            {dragOver ? <Upload className="w-5 h-5 text-indigo-500" data-id="element-18850" /> : <ImageIcon className="w-5 h-5 text-slate-400" data-id="element-18851" />}
          </div>
          <div className="text-sm font-medium text-indigo-600" data-id="element-18852">
            {dragOver ? 'Отпустите файл' : 'Выберите фото'}
          </div>
          <div className="text-xs text-slate-400 mt-0.5" data-id="element-18853">
            PNG, JPG, WebP до {maxSizeMB} МБ
          </div>
        </div>}

      {error && <p className="mt-1.5 text-xs text-rose-500" data-id="element-18854">{error}</p>}
    </div>;
}